import { merge } from 'global/lib/lodash';
import initialState from '../initialState';

export default function (state = initialState.db, action) {
  switch (action.type) {
    case 'SET_DB':
      return merge({}, state, action.data);
    default:
      return state;
  }
}
